import React, { useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { CardTitle } from "reactstrap";
import { TooltipComponent } from "../../../Component";
import { BarChart } from "../../charts/default/Charts";

const SalesGraph = () => {
	
  const graphs = useSelector((state) => state.graph.graphs);
   const [period, setPeriod] = useState(6);
  
const salesArray = Object.entries(graphs?.data?.sales || {}).map(
  ([month, value]) => ({
    label: month,
    value: Number(value),
  })
);  

    // 👉 Filter sales data based on period
  const filteredSales = useMemo(() => {
    if (!graphs?.data?.sales) return [];

   return salesArray.slice(-period);
  }, [graphs, period]);

  // 👉 Calculate total sales
  const totalSales = useMemo(() => {
    return filteredSales.reduce((sum, item) => sum + Number(item.value || 0), 0);
  }, [filteredSales]);
  
  return (
    <React.Fragment>
      {" "}
      <div className="card-title-group align-start mb-2">
        <CardTitle>
          <h6 className="title">Total Sales</h6>
          <p>In last {period} months sales data..</p>
				   <select
					className="form-select mt-2"
					style={{ width: "140px" }}
					value={period}
					onChange={(e) => setPeriod(Number(e.target.value))}
				  >
					<option value={1}>Last 1 Month</option>
					<option value={3}>Last 3 Months</option>
					<option value={6}>Last 6 Months</option>
					<option value={12}>Last 12 Months</option>
				  </select>
        </CardTitle>
		
        <div className="card-tools">
          <TooltipComponent icon="help-fill" iconClass="card-hint" direction="left" id="Tooltip-3" text="Total Sales" />
        </div>
      </div>
      <div className="align-end flex-sm-wrap g-4 flex-md-nowrap">
        <div className="nk-sale-data">
          <span className="amount">
             $
            {new Intl.NumberFormat("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(totalSales)}
          </span>
        </div>

        <div className="nk-sales-ck h-fit">

          <BarChart data={graphs?.data?.sales} label="Sales" />
        </div>
      </div>
    </React.Fragment>
  );
};
export default SalesGraph;
